import { cva, cx } from '@vizit/theme';
import { Column as AriaColumn, type ColumnProps as AriaColumnProps, composeRenderProps } from 'react-aria-components';

interface ColumnProps extends AriaColumnProps {
  /**
   * Additional CSS classes to apply to the column
   *
   * @optional
   * @type string
   */
  className?: string;
}

const columnClasses = cva({
  base: [
    'px-12 py-6 text-left font-semibold text-sm text-quaternary',
    'cursor-default whitespace-nowrap',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-inset',
    'focus-visible:relative focus-visible:z-20',
  ],
});

/**
 * A column component that wraps React Aria's Column with custom styling.
 *
 * @param props - The props for the Column component
 * @example
 * <Column>Product</Column>
 */
function TableHeaderColumn(props: ColumnProps) {
  const { className: classNameProp, ...other } = props;

  return (
    <AriaColumn
      className={composeRenderProps(classNameProp, (className) => cx(columnClasses({ className })))}
      {...other}
    />
  );
}

export { TableHeaderColumn };
export type { ColumnProps };
